import { useSyncExternalStore } from 'use-sync-external-store/shim'
import { useCallback } from 'react'
import { applyThemeDefaults, setThemeDefaults } from '../themes/themeUtil'

export function useThemeType () {
  return useSyncExternalStore(subscribe, getSnapshot)
}

function getSnapshot () {
  return document.documentElement.getAttribute('data-theme-type') || 'default'
}

function subscribe (callback) {
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.attributeName === 'data-theme-type') {
        callback()
        break
      }
    }
  })

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-theme-type']
  })

  return () => observer.disconnect()
}

export function useToggleThemeType () {
  const themeType = useThemeType()
  const toggleThemeType = useCallback(() => {
    const targetTheme = themeType === 'dark' ? 'light' : 'dark'
    setThemeDefaults(targetTheme)
    applyThemeDefaults()
  }, [themeType])

  return [themeType, toggleThemeType]
}
